import type { Board, CouponBoardIdentifiers } from '../../../../schema/coupon/entry.js';
import { CouponBoardEntity, type ICouponBoardEntity, type IDefinition, NotFoundError } from '../../../domain/entry.js';
import type { ICouponZustandStoreService } from '../../services/couponStoreService.js';
import { selectCouponBoard } from './selectors/selectCouponBoard.js';

type Store = ReturnType<ICouponZustandStoreService['bootstrap']>;

export class CouponBoardZustandEntity extends CouponBoardEntity implements ICouponBoardEntity {
  private readonly _store: Store;

  // eslint-disable-next-line @typescript-eslint/max-params
  constructor(model: Board, couponBoardIdentifiers: CouponBoardIdentifiers, definition: IDefinition, store: Store) {
    super(model, couponBoardIdentifiers, definition);
    this._store = store;
  }

  override get model(): Board {
    const board = selectCouponBoard(this.couponId, { couponIndex: this.couponIndex, boardIndex: this.boardIndex })(
      this._store.getState()
    );

    if (!board) {
      // Treat undefined as a special use case since normally this shouldn't happen,
      // this can happen due to that entity has access to the whole state so it gets updates to the model
      // without subscribing to it.

      throw new NotFoundError('Entity not found');
    }

    return board;
  }
}
